// F1-2 水平单图
import { FC } from 'react'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import { AspectRatio, IHorizontalSingleMediaProps, paddingTopClassMap, paddingBottomClassMap } from '@/common/pd-meta-components-types'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { useGSAP } from '@gsap/react'
import TitleAndDesc from '../../title-and-desc'
import TagItemRightIcon from '../../tag-item-right-icon'
import PdTextMatchSup from '@/components/pd-text-match-sup/pd-text-match-sup'
import SemanticText from '@/components/standard/semantic-text'

gsap.registerPlugin(ScrollTrigger, useGSAP)

const HorizontalSingleMedia: FC<IHorizontalSingleMediaProps> = ({
  theme,
  mediaGroup,
  title,
  titleTag,
  itemTitleTag,
  desc,
  mediaAspectRatio = AspectRatio.OneToOne,
  mediaBorderRadius = 0,
  paddingTop = 'px120',
  paddingBottom = 'px120',
}) => {
  useGSAP(() => {
    if (!mediaGroup?.length) return

    const createAnimationConfig = (index: number) => ({
      media: document.querySelector(`.target-f1-2-${index}`),
      container: document.querySelector(`.container-f1-2-${index}`),
      scrollTrigger: {
        scroller: '#main',
        trigger: `.container-f1-2-${index}`,
        start: 'top bottom',
        end: 'bottom bottom',
        scrub: true,
      },
    })

    const animations = mediaGroup
      .map((_, index) => {
        const { media, container, scrollTrigger } = createAnimationConfig(index)
        if (!media || !container) return null

        return gsap.to(media, {
          scale: 1,
          scrollTrigger,
        })
      })
      .filter(Boolean)

    return () => {
      animations.forEach((animation) => {
        if (animation?.scrollTrigger) {
          animation.scrollTrigger.kill()
        }
      })
    }
  }, [mediaGroup])

  return (
    <div className={clsx('w-full h-fit', paddingTopClassMap[paddingTop], paddingBottomClassMap[paddingBottom], `pd-theme-${theme}`, 'bg-container-primary')}>
      <TitleAndDesc title={title} desc={desc} titleTag={titleTag} />
      <div className={clsx('w-full mx-auto flex flex-col gap-8', 'laptop:w-300 laptop:gap-16', 'px-6 laptop:px-0')}>
        {mediaGroup?.map((item, index) => (
          <div
            key={item.title}
            className={clsx(
              'flex flex-col gap-5',
              'laptop:gap-12',
              index % 2 === 0 ? 'laptop:flex-row' : 'laptop:flex-row-reverse'
            )}
          >
            <div
              className={clsx('flex-none laptop:w-588px overflow-hidden', `container-f1-2-${index}`)}
              style={{ aspectRatio: mediaAspectRatio, borderRadius: `${mediaBorderRadius}px` }}
            >
              <PdMedia src={item.mediaUrl} mask={false} className={`target-f1-2-${index}`} />
            </div>
            <div className={clsx('flex-1', 'flex flex-col gap-5', 'laptop:gap-64px laptop:justify-center')}>
              <div>
                {/* title */}
                <div className={clsx('mb-1', 'laptop:mb-6')}>
                  <SemanticText
                    as={itemTitleTag}
                    defaultTag="h3"
                    className={clsx('font-semibold whitespace-pre-wrap', 'laptop:text-40 text-16', 'text-fc-primary')}
                  >
                    <PdTextMatchSup className="" supClassName="" text={item?.title || ''}></PdTextMatchSup>
                  </SemanticText>
                </div>
                {/* desc */}
                <p className={clsx('text-14 whitespace-pre-wrap', 'laptop:text-18', 'text-fc-secondary')}>
                  <PdTextMatchSup className="" supClassName="" text={item?.desc || ''}></PdTextMatchSup>
                </p>
              </div>
              <div className={clsx('flex justify-between laptop:gap-64px laptop:justify-start')}>
                {item?.infoGroup?.map((ele) => (
                  <TagItemRightIcon key={ele.title} {...ele} titleClassName="!text-brand-primary" />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default HorizontalSingleMedia
